/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
function values(obj) {
    return Object.keys(obj).map(key => obj[key]);
}
function isDefined(obj) {
    return typeof obj !== 'undefined';
}

export { isDefined, values };
